import { render, staticRenderFns } from "./PurchaseTransactions.vue?vue&type=template&id=b50b235e&scoped=true"
import script from "./PurchaseTransactions.vue?vue&type=script&lang=js"
export * from "./PurchaseTransactions.vue?vue&type=script&lang=js"
import style0 from "./PurchaseTransactions.vue?vue&type=style&index=0&id=b50b235e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50b235e",
  null
  
)

export default component.exports